const ConstantsPlugin = {
    install(vue) {
        const constants = {
            APP_NAME: process.env.VUE_APP_APP_NAME || 'Sertracen',
            SESSION_COOKIE: process.env.VUE_APP_SESSION_COOKIE || 'sertracen_admin_session',
            CLIENT_ID: process.env.VUE_APP_CLIENT_ID,
            CLIENT_SECRET: process.env.VUE_APP_CLIENT_SECRET,
            DEFAULT_LANG: process.env.VUE_APP_DEFAULT_LANG || 'es',
        };
        vue.$constants = constants;
        vue.prototype.$constants = constants;
    }
};

export default ConstantsPlugin;
